import placeholder from "../../../assets/images/placeholder.svg";

const ImagePicker = ({ handleImageUpload, image, imageId }) => {
  return (
    <div className="imagePickerConatiner">
      <label for={`file-ip-${imageId}`}>
        <div>
          <img src={image ? image : placeholder} alt="item image" title="" />
        </div>
      </label>
      <input
        id={`file-ip-${imageId}`}
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
      />
    </div>
  );
};

export default ImagePicker;
